import { Type } from '../type/Type.js';
export function objectRemoveUndefined(obj, recursive = false) {
    for (const key in obj) {
        // only traverse owned properties
        if (obj.hasOwnProperty(key)) {
            // if recursing and we have a primitive iterable, walk in
            if (recursive && Type.isPrimitiveIterable(obj[key])) {
                objectRemoveUndefined(obj[key]);
            }
            // if key is undefined, delete it
            if (obj[key] === undefined) {
                delete obj[key];
            }
        }
    }
}
//# sourceMappingURL=objectRemoveUndefined.js.map